import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  storeId: validator('presence', {
    presence: true,
  }),
  accessToken: validator('presence', {
    presence: true,
  }),
  contentOwnerChannel: [validator('belongs-to'), validator('presence', true)],
});

export default class ShopifyStoreModel extends Model.extend(Validations) {
  @attr('string') storeId;
  @attr('string') accessToken;
  @attr('string') revokationUrl;
  @attr('boolean') productSync;
  @attr('boolean', { defaultValue: true }) showShopBranding;
  @attr('string') shopBrandingName;

  // Relations
  @belongsTo('channel', { async: true, inverse: null }) contentOwnerChannel;
  @belongsTo('channel', { async: true, inverse: null }) channel;
  @hasMany('taxon', { async: true, inverse: null }) taxa;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Getter and setter
  get displayHeadline() {
    return this.storeId;
  }

  get displayLabel() {
    return this.storeId;
  }
}
